const hasValue = (state) => {
	if (state) {
		return Boolean(state.value)
	}
	return false;
}
const returnValue = (state) => {
	return state.value
}

const validateEmail = (email) => {
	let pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return pattern.test(email);
}


Object.filter = function (obj, predicate) {
	var result = {},
		key;
	for (key in obj) {
		if (obj.hasOwnProperty(key) && predicate(obj[key])) {
			result[key] = obj[key];
		}
	}

	return result;
};




const checkInput = (state, errorCallback) => {

	if (!state) return;

	const errors = {
		FullName: "יש למלא שם",
		Email: "יש למלא מייל תקין",
		Age: "יש למלא גיל",
		Gender: "יש לבחור מין",
		RecipeSteps: "יש לפרט על המתכון ואופן ההכנה",
		RecipeName: "יש לתת שם למתכון",
		PhoneNumber: "יש להזין מספר טלפון תקין",
		// FileName: "לא נבחר קובץ"
	}

	switch (state.name) {
		case "RecipeSteps":
		// case "FileName":
		case "FullName":
			if (state.value.length < 2) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
			case "RecipeName":
				if (state.value.length < 2 || state.value.length > 50) {
					errorCallback(state, errors[state.name]);
					return false;
				}
				break;
		case "Age":
			if (state.value.length < 1) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "Gender":
			if (state.value == -1) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "MyTrip":
			if (state.value.length < 3) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "PhoneNumber":
			if (state.value.length < 7 || state.value.length > 15) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "Email":
			if (!validateEmail(state.value)) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "Terms":
			if (state.value != 1) {
				alert("עליך לאשר את הסכמתך לתקנון על מנת להמשיך");
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
			// case "FamilyImage":
			// 	if (!state.value) {
			// 		this.setErrorMessage(state, errors[state.name]);
			// 		return false;
			// 	}
			// 	break;
	}
	return true;
}

export {
	validateEmail,
	returnValue,
	hasValue,
	checkInput

}


// WEBPACK FOOTER //
// ./src/Components/Services/Validation.js